import { phoneNumberRegex } from "./common";
import i18n from "../lang/i18n";
const validations = {
  school_name: {
    required: true,
    maxLength: 255
  },
  fax: {
    required: true,
    maxLength: 255,
    format: {
      valid: value => phoneNumberRegex.test(value.trim()),
      message: i18n.t("validation.the_fax_number_invalid")
    }
  },
  principal: {
    required: true,
    maxLength: 255
  },
  address: {
    required: true,
    maxLength: 255
  },
  phone_number: {
    required: true,
    maxLength: 255,
    format: {
      valid: value => phoneNumberRegex.test(value.trim()),
      message: i18n.t("validation.the_phone_number_invalid")
    }
  },
  parameter_name: {
    required: true,
    maxLength: 255
  },
  timezone: {
    required: true,
    maxLength: 255
  },
  weight: {
    required: true,
    format: {
      valid: value => /^((100)|(\d{1,4}(\.\d*)?))$/.test(value.trim()),
      message: i18n.t("validation.the_weight_must_be_number_from_0_to_100")
    }
  },
  account: {
    required: true,
    maxLength: 255
  },
  password: {
    required: true,
    maxLength: 255,
    format: {
      valid: value => /^.{6,}$/.test(value.trim()),
      message: i18n.t("validation.password_must_be_greater")
    }
  }
};
export { validations };
